import { TelephoneFill, Envelope, GeoAltFill } from "react-bootstrap-icons";
import language from "../../data/language";
import { currentLanguage } from "./notify";

export const PHONE = "032-242-41-00";
export const PHONE_HREF = "tel:0322424100";
export const EMAIL = "info@carexpress.ge";
export const MAP_URL = "https://www.google.com/maps/place/Green+Budapest/@41.7280726,44.7599079,848m/data=!3m1!1e3!4m15!1m8!3m7!1s0x404472e056fc11f7:0x2f85a5fc0a78c195!2s22+Guram+Panjikidze+St,+T'bilisi!3b1!8m2!3d41.7280686!4d44.7624828!16s%2Fg%2F11_qprv9v!3m5!1s0x404472e102e66fab:0xbf2bcc2b2ca4a90a!8m2!3d41.7288863!4d44.7630619!16s%2Fg%2F11cnqsfd_j";
export const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=995595999929";

/**
 * Phone / email / address cards. Repeated at the foot of every marketing page,
 * which is why it lives here instead of being copy-pasted per page.
 */
const ContactStrip = () => {
    const lang = currentLanguage();
    const strings = language[lang].home_page;

    return (
        <div className="cx-contact-strip">
            <div className="cx-contact-card">
                <span className="cx-contact-icon"><TelephoneFill /></span>
                <div className="cx-contact-body">
                    <span className="cx-contact-label">{strings.call_us}</span>
                    <a className="cx-contact-value" href={PHONE_HREF}>{PHONE}</a>
                </div>
            </div>
            <div className="cx-contact-card">
                <span className="cx-contact-icon"><Envelope /></span>
                <div className="cx-contact-body">
                    <span className="cx-contact-label">{strings.write_us}</span>
                    <a className="cx-contact-value" href={`mailto:${EMAIL}`}>{EMAIL}</a>
                </div>
            </div>
            <div className="cx-contact-card">
                <span className="cx-contact-icon"><GeoAltFill /></span>
                <div className="cx-contact-body">
                    <span className="cx-contact-label">{strings.address}</span>
                    <a className="cx-contact-value" href={MAP_URL} target="_blank" rel="noreferrer">
                        {strings.our_address}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactStrip;
